import {useOutletContext} from "react-router-dom";
import {Profile} from "@/api/types.ts";
import {useTranslation} from "react-i18next";
import {Avatar, Caption, Cell, Headline, Section, Subheadline} from "@telegram-apps/telegram-ui";
import {Page} from "@/components/Page.tsx";
import {WishlistCell} from "@/components/Wishlist/WIshlistCell.tsx";
import {openExternalLink} from "@/helpers/openExternalLink.ts";
import {getUserAcronym} from "@/helpers/getUserAcronym.ts";
import {TbChevronRight, TbSparkles} from "react-icons/tb";
import {useNavigation} from "@/providers/NavigationProvider.tsx";

export const ProfilePage = () => {
  const { profile } = useOutletContext<{profile: Profile}>();
  const { t, i18n: {language} } = useTranslation();
  const { navigateToRoute } = useNavigation();

  const formatDateString = (date: Date | null) => {
    if (!date) {
      return null;
    }
    return date.toLocaleDateString(language, {year: "numeric", month: "long", day: "numeric"});
  }

  const tgUsername = profile.user.tgUsername?.replace(/^@/, "");

  return <Page>
    <div className={"flex flex-col gap-3 pb-10"}>
      <div className={"p-3 pb-3 rounded-xl bg-section flex flex-col gap-3"}>
        <div className={"flex justify-center pb-3"}>
          <div className={"flex gap-3 items-center"}>
            <Avatar size={96}
                    acronym={getUserAcronym(profile.user.fullname)}
                    src={profile.user.photo?.sizes[0]?.link}></Avatar>
            <div className={"w-full"}>
              <Subheadline level={"2"} className={"text-color-hint"}>{t('profile.titleOtherProfile')}</Subheadline>
              <Headline className={"tg-link-color"}>
                {profile.user.fullname}
              </Headline>
              {tgUsername && (
                <Caption size={1} className={"tg-link-color"}
                         onClick={() => openExternalLink(`https://t.me/${tgUsername}`)}>
                  @{tgUsername}
                </Caption>
              )}
              <br />
              <Caption>
                {t('profile.birthday')}: {formatDateString(profile.user.birthday) || "—"}
              </Caption>
            </div>
          </div>
        </div>
        <Cell after={<TbChevronRight size={20}/>}
              before={<TbSparkles size={20}/>}
              className={"tg-link-color cell-compact-padding"}
              onClick={() => {
                navigateToRoute(`/profiles/${profile.user.id}/wishes/gifted`);
              }}
        >
          {t('profile.giftedWishes')}
        </Cell>
      </div>

      <Section header={t('profile.titleUserWishlists')}>
        {profile.wishlistPreviews.map((wishlist) => (
          <WishlistCell key={"wishlistPreview_"+wishlist.id} wishlist={wishlist}/>
        ))}

        {profile.wishlistPreviews.length === 0 && <div className={"p-5 text-center"}>
          <Caption className={"text-color-hint"}>
            {t('state.noPublicWishlists')}
          </Caption>
        </div>}
      </Section>
    </div>
  </Page>
}
